module.exports = __webpack_public_path__ + "img/support_system@2x.9741ac89.png";